module.exports = __webpack_public_path__ + "img/details_proser.defec0d9.png";